// extracted by mini-css-extract-plugin
module.exports = {"title":"panel-content-small_title__33a9m"};